<template>
    <MDBCol cols="12" md="3">
        <h5 class="mb-2">{{ $t('onboarding.selectTyres') }}</h5>
        <div v-for="(label, key) in tyreOptions" :key="key" class="d-flex">
            <input :id="`vehicle-type-${key}`" class="form-check-input" type="checkbox" :value="true"
                :checked="selections[key]" :disabled="loading" @change="$emit('changeSelection', key)" />
            <label :for="`vehicle-type-${key}`" class="form-check-label ps-3">{{ $t(label) }}</label>
        </div>
    </MDBCol>
</template>

<script setup>
import { MDBCol } from "mdb-vue-ui-kit";
import { defineProps } from "vue";
defineProps({
    selections: Object,
    loading: Boolean,
});

const tyreOptions = {
    carTyres: 'onboarding.carTyres',
    motorcyclesTyres: 'onboarding.motorcyclesTyres',
    truckBusTyres: 'onboarding.truckBusTyres',
    agricultureTyres: 'onboarding.agricultureTyres',
    otrTyres: 'onboarding.otrTyres'
};
</script>